import { render, staticRenderFns } from "./Lgx196037285584568320.vue?vue&type=template&id=4875e82f&"
import script from "./Lgx196037285584568320.vue?vue&type=script&lang=js&"
export * from "./Lgx196037285584568320.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports